import BucketApiRequest from "./BucketApiRequest";
import { GET_PROVINCE_LIST } from "../ApiUrls";

export default class GetProvinceList extends BucketApiRequest {
  getUrl = () => {
    return GET_PROVINCE_LIST;
  };
}
